// This file can be replaced during build by using the `fileReplacements` array.
// `ng build` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

export const environment = {
  production: false,
  firebase: {
    apiKey: "AIzaSyB8C3wRT98htOYLARh-k2mz2u7fPB0JtmA",
    authDomain: "melowish-dev.firebaseapp.com",
    projectId: "melowish-dev",
    storageBucket: "melowish-dev-pub",
    messagingSenderId: "304892017334",
    appId: "1:304892017334:web:88ea8b58cd6dc271908417"
  },
  stripePublishableKey: 'pk_test_51Sf8GzGJj6qOoHCFQuGAc0B3vr52FGenWsP5G7baDkor350guvNt3Or7orvEvLllvARt7rN1hVVsUwptuHL4gDAB00OX3n0fbE',
  firebaseRegion: 'europe-west1',
  useFirebaseEmulator: false,
  // Basis fuer geteilte Links, wenn window.location.origin nicht brauchbar ist
  // (native App: capacitor://localhost).
  appBaseUrl: 'https://dev.melowish.com',

  /**
   * Schaltet die Einwilligungsabfrage scharf.
   *
   * false: kein Dialog, First-Touch wird unbedingt gespeichert. Bewusst so fuer
   *        die Testphase, damit die Attribution ueber Sitzungen messbar ist.
   * true:  Dialog erscheint, First-Touch nur mit Einwilligung.
   *
   * Unabhaengig davon feuert der Meta-Pixel NUR bei echter Einwilligung - ein
   * Flag kann keine Rechtsgrundlage ersetzen. Zum Testen des Pixels also hier
   * auf true stellen und im Dialog zustimmen.
   *
   * MUSS vor dem ersten Ad-Budget auf true.
   */
  consentRequired: true,

  /** Meta-Pixel-ID. Oeffentlich, steht ohnehin im Browser. Leer = Pixel aus. */
  metaPixelId: '1406124794772519'
};
// export const environment = {
//   production: true,
//   firebase: {
//     apiKey: "AIzaSyCML5LtjXTGHIMOmka7HFXAzhjBD1eDtOU",
//     authDomain: "melowish-prod.firebaseapp.com",
//     projectId: "melowish-prod",
//     storageBucket: "melowish-prod.firebasestorage.app",
//     messagingSenderId: "237788363004",
//     appId: "1:237788363004:web:12cc4c24d8698879fa7f79",
//     measurementId: "G-9PEF9BBTZ6"
//   },
//   stripePublishableKey: 'pk_live_51Sf8GzGJj6qOoHCFa4gCFwsmNdZelBMsHPBEIj6yzwLbPXgtc7dVZyaICADge3V7MBe8d8J1SzI8gMoH39lVZfGh00zA6nXQJ5',
//   firebaseRegion: 'europe-west1',
//   useFirebaseEmulator: false
// };


/*
 * For easier debugging in development mode, you can import the following file
 * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
 *
 * This import should be commented out in production mode because it will have a negative impact
 * on performance if an error is thrown.
 */
// import 'zone.js/plugins/zone-error';  // Included with Angular CLI.
